import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.5 9H13v6h-1.5V9zM10 9H5v6h5v-3H8.5v1.5h-2v-3H10V9zm9 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1h3z"
}), 'GifSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/GifSharp.js
// module id = 3997
// module chunks = 2